import { c as _c } from "react/compiler-runtime";
import { SanitizeHtmlUtils } from "@stellar/utils/sanitize-html";
/**
 * This component wrap the provided markup into a dangerouslySetInnerHTML.
 * A use case of it is when an error is received from backend. They might already be in the shape of html
 * !: It should only be used if there is no other options. *
 */
export function SanitizedHtmlTag(t0) {
  const $ = _c(4);
  const {
    markup
  } = t0;
  let t1;
  if ($[0] !== markup) {
    t1 = SanitizeHtmlUtils.sanitizeString(markup);
    $[0] = markup;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div dangerouslySetInnerHTML={{
      __html: t1
    }} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}